import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faBlogger, faYoutube } from '@fortawesome/free-brands-svg-icons';
import KakaoOfficeMap from './KakaoOfficeMap';

const ContactInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="contact-info">
      <h3>{t('contact.info.title')}</h3>

      <div className="contact-item">
        <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
        <div>
          <h4>{t('contact.info.email')}</h4>
          <p>contact@tchelp.org</p>
        </div>
      </div>

      <div className="contact-item">
        <FontAwesomeIcon icon={faPhone} className="contact-icon" />
        <div>
          <h4>{t('contact.info.phone')}</h4>
          <p>070-8028-3509</p>
        </div>
      </div>

      <div className="contact-item">
        <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
        <div>
          <h4>{t('contact.info.address')}</h4>
          <p>{t('contact.info.addressDetail')}</p>
          <KakaoOfficeMap />
        </div>
      </div>

      <div className="social-links">
        <h4>{t('contact.info.social')}</h4>
        <div className="social-icons">
          <a href="https://instagram.com/tchelp_korea" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://blog.naver.com/tchelpkorea" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faBlogger} />
          </a>
          <a href="https://youtube.com/@tchelp_korea" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
